import { format, parseISO } from "date-fns";

const FormatIsoDate = (timestamp) => {
  const datetime = format(parseISO(timestamp), "MMM d, yyyy h:m");

  return datetime;
};

export default FormatIsoDate;
